import { createNamespacedHelpers } from 'vuex-composition-helpers/dist';

export default function useVacanciesList() {
  const { useActions, useState } = createNamespacedHelpers('vacanciesList');
  const { vacanciesList, vacancies, vacanciesMetaData } = useState(['vacanciesList', 'vacancies', 'vacanciesMetaData']);
  const { fetchVacanciesList, fetchVacancies } = useActions(['fetchVacanciesList', 'fetchVacancies']);

  return {
    fetchVacanciesList,
    fetchVacancies,
    vacanciesList,
    vacancies,
    vacanciesMetaData,
  };
}
